function styleWithdrawButton() {
  const btn = document.querySelector("#withdraw-modal")?.shadowRoot?.querySelector("button");
  if (!btn) return;

  btn.style.backgroundColor = "#ec2041";
  btn.style.borderColor = "#ec2041";
}

// Add friends button

function styleRequestsModalButtonMargin() {
  const btn = document.querySelector("#requests-modal")?.shadowRoot?.querySelector("button");
  if (!btn) return;

  btn.style.marginLeft = "4px";
  btn.style.padding = "4px";
}

// Friends search input text
function styleSearchbarInput() {
  const input = document.querySelector(
    "#root > ion-app > div > ion-tabs > div > ion-router-outlet > div > ion-content > ion-header > ion-searchbar > div > input"
  );
  if (!input) return;

  input.style.fontSize = "14px";
  input.style.paddingLeft = "35px";
}

// Hide small friends button
function hideRequestsModalButton() {
  const btn = document.querySelector("#requests-modal")?.shadowRoot?.querySelector("button");
  if (!btn) return;

  btn.style.display = "none";
}

// Align invite friends button
function styleMainToolbarContainer() {
  const container = document
    .querySelector("#root > ion-app > div > ion-tabs > div > ion-router-outlet > div > ion-content > ion-header > ion-toolbar")
    ?.shadowRoot?.querySelector("div.toolbar-container");

  if (!container) return;

  container.style.display = "flex";
  container.style.alignItems = "center";
  container.style.paddingRight = "10px";
}

// Transaction tab small tabs padding
function styleSecondTabListItem() {
  const item = document
    .querySelector(
      "#root > ion-app > div > ion-tabs > div > ion-router-outlet > div:nth-child(2) > ion-content > ion-list > ion-item.sticky.top-0.item-segment.item.ios.item-fill-none.in-list.ion-focusable"
    )
    ?.shadowRoot?.querySelector("div.item-native");

  if (!item) return;

  item.style.paddingTop = "0";
  item.style.paddingBottom = "0";
}

// Friends tab header background color
function styleFriendsToolbarBg() {
  const ionToolbar = document.querySelector("ion-router-outlet .ion-page--friends ion-header ion-toolbar");
  const bg = ionToolbar?.shadowRoot?.querySelector(".toolbar-background");
  if (!bg) return;

  bg.style.backgroundColor = "#0E1832";
  bg.style.background = "#0E1832";
  bg.style.borderColor = "#3A67D0";
}

// Wallet tab header background color
function styleWalletToolbarBg() {
  const ionToolbar = document.querySelector("ion-router-outlet .ion-page--wallet ion-header ion-toolbar");
  const bg = ionToolbar?.shadowRoot?.querySelector(".toolbar-background");
  if (!bg) return;

  bg.style.backgroundColor = "#0E1832";
  bg.style.background = "#0E1832";
  bg.style.borderColor = "#3A67D0";
}

// Close button styling
function applyCloseMenuPadding() {
  const btn = document.querySelector("#close_button_menu")?.shadowRoot?.querySelector("button");
  if (!btn) return;

  btn.style.padding = "4px";
  btn.style.fontSize = "16px";
}

function styleFirstIonItemInputWrapper() {
  const items = document.querySelectorAll("#ion-react-wrapper ion-content ion-list ion-item");
  if (!items.length) return;

  items.forEach((item) => {
    if (!item.shadowRoot) return;

    // Try the best containers in order
    const target =
      item.shadowRoot.querySelector(".item-inner") ||
      item.shadowRoot.querySelector("div.item-native > div.item-inner") ||
      item.shadowRoot.querySelector(".input-wrapper") ||
      item.shadowRoot.querySelector("div.item-native .input-wrapper");

    if (!target) return;

    target.style.display = "flex";
    target.style.flexDirection = "column";
  });
}

function stackNotificationItemsColumn() {
  document.querySelectorAll("ion-modal ion-item").forEach((item) => {
    if (!item.shadowRoot) return;

    const label = item.shadowRoot.querySelector("ion-label");
    const inner = item.shadowRoot.querySelector(".item-inner");
    if (!label || !inner) return;

    // find the timestamp IonText that is currently outside the label
    // (in the light DOM of the ion-item)
    const timestamp = Array.from(item.children).find(
      (el) => el.tagName === "ION-TEXT" && el.querySelector("#timestamp_style_text")
    );

    if (timestamp && !label.contains(timestamp)) {
      label.appendChild(timestamp); // move it under the label
    }

    // ensure label stacks
    label.style.display = "flex";
    label.style.flexDirection = "column";
    label.style.gap = "6px";

    // keep item layout stable
    inner.style.alignItems = "flex-start";
  });
}


// ✅ NEW: run everything
function runAllPatches() {
  styleWithdrawButton();
  styleRequestsModalButtonMargin();
  styleSearchbarInput();
  hideRequestsModalButton();
  styleMainToolbarContainer();
  styleSecondTabListItem();
  styleFriendsToolbarBg();
  styleWalletToolbarBg();
  applyCloseMenuPadding();
  styleFirstIonItemInputWrapper(); 
  stackNotificationItemsColumn()
}

// run once now
runAllPatches();

// ✅ one observer reruns ALL patches after tab switches / rerenders
const root = document.querySelector("ion-app") || document.body;

let raf = 0;
new MutationObserver(() => {
  if (raf) return;
  raf = requestAnimationFrame(() => {
    raf = 0;
    runAllPatches();
  });
}).observe(root, { childList: true, subtree: true });
